import consumer from './cable';

$(document).ready(() => {
  // This function is executed after 3mn if Doclift does not answer.
  function docliftDoesNotAnswer() {
    if (!(typeof(iframe) == 'object')) {
      consumer.disconnect();
    }
  };

  function generateUniversignIframe(signerId) {
    const configuration = {};
    configuration.redirectionMode = 'OUT';

    /**
    * The universignSigInit function add an iframe element as child of element with
    * id attribute equals to containerId parameter, the attribute src is set from
    * the universignUrl variable, it is the url of the website to be integrated in
    * the iframe, the width and height of the iframe will take 100% of its
    * container.
    *
    * @param {string} containerId The id of the element in which we will inject
    * the iframe.
    * @param {string} signerId The identifier of transaction.
    * @param {object} configuration The options list to customize the iframe:
    * * redirectionMode {string} This params have two possible values: IN or OUT,
    * the dafault value is OUT,
    * if the value of this params is equal to OUT the redirection will be done
    * outside the iframe(in website container of the iframe),
    * if the value of this params is equal to ÌN the redirection will be done
    * inside the iframe,
    * if the value of this params is otherwise, an exception will be triggered.
    **/

    universignSigInit('iframeContainerId', signerId, configuration, $('#iframe-end-point').data('id'));
  }

  let docliftDoesNotAnswerTimer = setTimeout(docliftDoesNotAnswer, 180000);

  if ($('#signature-contribution-id').length) {
    consumer.subscriptions.create(
      { channel: 'SignatureChannel', contribution_id: $('#signature-contribution-id').data('id') }, {
        received(data) {
          if (data.status == 'success') {
            $('#contractLoader').addClass('d-none');
            $('#iconLoader').addClass('d-none');
            clearTimeout(docliftDoesNotAnswerTimer);
            generateUniversignIframe(data.e_sign_id)
          } else {
            $('#iconLoader').addClass('d-none');
            $('#loadingError').removeClass('d-none');
          }
        }
      }
    );
  };
});
